import type { Schema } from '@biteinc/common';
import { OrderChannel } from '@biteinc/enums';

export const createLocationSchema: Schema.Model = {
  displayName: 'location',
  type: 'object',
  fields: {
    orderChannel: {
      displayName: 'Order Channel',
      type: 'stringEnum',
      enum: OrderChannel,
      required: true,
      isReadOnly: true,
    },
    channelName: {
      type: 'shortString',
      displayName: 'Channel Name',
      required: true,
    },
    orgAppearanceId: {
      type: 'mongoId',
      displayName: 'Org Appearance',
      required: true,
      ui: 'dropdown',
    },
    phoneNumber: {
      type: 'phone',
      displayName: 'Phone Number',
    },
    fullAddress: {
      type: 'object',
      subtype: 'Address',
      displayName: 'Full Civic Address',
    },
  },
};
